
const testimonials = [
  {
    name: 'María González',
    location: 'Vic Centre Històric',
    rating: 5,
    text: 'Excelente servicio de vaciado de piso. Muy profesionales y discretos. Dejaron todo impecable y gestionaron todos los residuos. Totalmente recomendable.',
    service: 'Vaciado de piso',
  },
  {
    name: 'Josep Martínez',
    location: 'Manlleu',
    rating: 5,
    text: 'Necesitaba vaciar un local comercial urgentemente y respondieron de inmediato. El equipo fue muy eficiente y el precio muy ajustado. Muy contentos con el resultado.',
    service: 'Vaciado de local',
  },
  {
    name: 'Anna Puig',
    location: 'Torelló',
    rating: 5,
    text: 'Trato excepcional en un caso de síndrome de Diógenes. Fueron muy respetuosos y discretos. Hicieron un trabajo impresionante. Gracias por vuestra profesionalidad.',
    service: 'Limpieza Diógenes',
  },
  {
    name: 'Carles Roca',
    location: 'Vic El Remei',
    rating: 5,
    text: 'Servicio completo de vaciado y limpieza extrema. El equipo fue puntual, trabajaron rápido y dejaron el piso como nuevo. Relación calidad-precio inmejorable.',
    service: 'Limpieza extrema',
  },
];

export default function TestimonialsSection() {
  return (
    <section className="py-16 sm:py-20 bg-gradient-to-br from-gray-50 to-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-dark mb-4 px-2">
            Opiniones de nuestros clientes
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-2xl mx-auto px-4">
            La satisfacción de nuestros clientes es nuestra mejor carta de presentación. Lee lo que opinan sobre nuestros servicios de vaciado y limpieza en Vic y Osona.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
          {testimonials.map((testimonial, index) => (
            <article
              key={index}
              className="bg-white border border-gray-200 rounded-lg p-5 sm:p-6 hover:shadow-xl transition-all duration-300"
            >
              <div className="flex items-center mb-4" role="img" aria-label={`${testimonial.rating} estrellas de 5`}>
                {[...Array(testimonial.rating)].map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-star-fill text-yellow-400 text-base" aria-hidden="true"></i>
                  </div>
                ))}
              </div>
              <p className="text-sm text-gray-700 mb-4 leading-relaxed italic break-words">
                "{testimonial.text}"
              </p>
              <div className="border-t border-gray-200 pt-4">
                <div className="font-semibold text-dark text-sm break-words">{testimonial.name}</div>
                <div className="text-xs text-gray-500 mt-1 break-words">{testimonial.location}</div>
                <div className="text-xs text-primary font-medium mt-1 break-words">{testimonial.service}</div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
